import React from "react";
import "./ChairmanReport.scss";
// import chairmanImg from "../../../assets/Gallery/chairman-new-img.jpg";
import chairmanImg from "../../../assets/Gallery/chairman-new.png";
// import chairmanSign from "../../../assets/chairmanSign.png";
import chairmanSign from "../../../assets/Gallery/chairman-sign.png";

const ChairmanReport = () => {
  return (
    <>
      <div className="chairman_report">
        <div className="container">
          <div className="heading_box">Chairman's Message</div>
          <div className="chairman_report_text">
            <h5 className="text-center mb-5">Bismillahir Rahmanir Raheem</h5>

            <div className="row">
              <div className="col-lg-8 mt-auto">
                <p>Dear Shareholders</p>
                {/* <p>Assalamu Alaikum,</p> */}
                <p>
                  It is both an honor and a privilege to present the Annual
                  Report of Rupali Insurance Company Limited for the year ended
                  December 31, 2025.
                </p>
                <p>
                  The year 2025 was characterized by a dynamic business
                  environment shaped by persistent inflationary pressures,
                  evolving regulatory requirements, foreign exchange volatility,
                  and global economic uncertainties. Despite these challenges,
                  Bangladesh's economy continued to demonstrate resilience,
                  supported by strong domestic demand, export growth, and
                  ongoing infrastructure development. Against this backdrop,
                  Rupali Insurance Company Limited remained steadfast in its
                  commitment to prudent underwriting, sound corporate
                  governance, financial discipline, and superior customer
                  service.
                </p>
                <p>
                  I am pleased to report that the Company delivered a
                  satisfactory performance during the year, maintaining its
                  position as a trusted and dependable insurer in Bangladesh.
                  Through the collective efforts of our management team,
                  employees, agents, and business partners, Rupali Insurance
                  continued to strengthen its market presence while upholding
                  the highest standards of professionalism, integrity, and
                  service excellence. The Company achieved a Gross Premium
                  Income of Tk. 761.71 million and recorded a Net Profit Before
                  Tax of Tk. 77.90 million, reflecting the strength of our
                  business model and the confidence reposed in us by our valued
                  policyholders and stakeholders.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end text-center order-first order-lg-last">
                <img
                  src={chairmanImg}
                  className="img-fluid my-3 w-75 rounded shadow"
                  alt="Chairman's Message"
                />
              </div>
            </div>

            <p>
              The year held particular significance for our Company as we
              continued to build upon the strong foundation established by our
              late Founder and Former Chairman, Mr. Mostafa Golam Quddus. His
              visionary leadership, entrepreneurial spirit, and unwavering
              commitment to excellence played a pivotal role in transforming
              Rupali Insurance into one of the country's respected insurance
              institutions. On behalf of the Board of Directors, I pay tribute
              to his remarkable legacy and reaffirm our commitment to preserving
              the values, principles, and standards that he instilled within the
              organization.
            </p>

            <p>
              During the year, we continued to focus on strengthening our core
              operations through enhanced risk management practices, regulatory
              compliance, digital process improvements, and operational
              efficiency. The Board remained committed to ensuring transparency,
              accountability, and sound governance across all levels of the
              organization. These efforts have further strengthened the
              Company's financial stability and positioned it for sustainable
              long-term growth.
            </p>

            <p>
              The insurance industry is undergoing significant transformation
              driven by technological advancement, changing customer
              expectations, and increased awareness regarding risk protection.
              We view these developments not merely as challenges but as
              opportunities to innovate, diversify our products and services,
              and improve customer engagement. Rupali Insurance remains
              committed to embracing technology, enhancing service delivery, and
              developing solutions that meet the evolving needs of individuals
              and businesses across Bangladesh.
            </p>
            <p>
              Looking ahead, our strategic priorities will focus on sustainable
              growth, portfolio diversification, improved operational
              efficiency, digital transformation, and the creation of long-term
              value for our shareholders. We will continue to strengthen our
              market position through prudent business practices while
              maintaining a balanced approach to growth and risk management.
            </p>
            <p>
              On behalf of the Board of Directors, I extend my sincere gratitude
              to our respected shareholders for their continued confidence, our
              valued policyholders for their trust, our regulators for their
              guidance, our business partners for their collaboration, and our
              employees for their dedication and professionalism. Their
              collective support remains the cornerstone of our success.
            </p>
            <p>
              I am confident that, with the blessings of Almighty Allah and the
              continued commitment of all stakeholders, Rupali Insurance Company
              Limited will further strengthen its position as a leading non-life
              insurance company in Bangladesh and continue its journey toward
              sustainable growth, excellence, and long-term prosperity.
            </p>

            <p>
              May Allah bless our endeavors and guide us toward greater success
              in the years ahead.
              <br />
              <br />
            </p>
            <div className="row">
              <div className="col-lg-6">
                <h5>Mostafa Quamrus Sobhan</h5>
                <h6>Chairman</h6>
              </div>
              {/* <div className="col-lg-6 text-end">
                <img src={chairmanSign} className="img-fluid" alt="" />
              </div> */}
            </div>

            <div className="chairman_sign"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChairmanReport;
